// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"631c455e","246":"f76a8523","584":"b5e2d93f","728":"c0f3e0e6","978":"b5e2d93f"}[chunkId] + ".chunk.css";
};